import { useToast } from '@cad-arc';
import { ContextMenuItemView, UnitContextMenuClickParams } from '@mark43/cad-api';
import { createApiErrorHandler } from '@m43/core';
import { errorOccurredWhile } from '../common/helpers/error-occurred-while';
import { ContextMenuItem } from '../context-menus/components/context-menu-item';
import { useReleaseBackupUnitsApi } from './use-release-backup-units-api';

export function ReleaseBackupItem({
    contextMenuItemView,
    clickParams,
}: {
    contextMenuItemView: ContextMenuItemView;
    clickParams: UnitContextMenuClickParams;
}): React.ReactElement {
    const releaseBackupUnits = useReleaseBackupUnitsApi();
    const toast = useToast();
    return (
        <ContextMenuItem
            dataPendoId="menu-item-release-backup"
            contextMenuItemView={contextMenuItemView}
            onSelect={() => {
                if (clickParams.eventId) {
                    releaseBackupUnits(clickParams.eventId).catch(
                        createApiErrorHandler(() => {
                            toast({
                                status: 'error',
                                description: errorOccurredWhile('releasing backup units'),
                            });
                        })
                    );
                }
            }}
        />
    );
}
